import { useAppSelector } from 'app/hooks';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import { selectPlantAnalytics } from 'features/Analysis/analysisSlice';
import { useEffect, useRef, useState } from 'react';
import style from '../../pages/Analysis/Analysis.module.scss';

function AnalysisInfoChart(props) {
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const assetAnalytics = useAppSelector(selectPlantAnalytics);
  const listColor = [
    '#E11D48',
    '#0284C7',
    '#059669',
    '#FB7185',
    '#A21CAF',
    '#4338CA',
    '#60A5FA',
    '#164E63',
    '#2DD4BF',
    '#365314',
    '#CA8A04',
    '#FACC15',
    '#EA580C',
    '#F97316',
    '#7F1D1D',
    '#44403C',
    '#A3A3A3',
    '#0F172A',
    '#64748B',
    '#FB923C',
  ];
  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(assetAnalytics);
    }
  }, [assetAnalytics]);

  const installDataset = (listOne) => {
    let newList = [];
    for (let i = 0; i < listOne.length; i++) {
      let newItem = {
        type: 'bar',
        label: listOne[i].label,
        data: listOne[i].assetInfo,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'title',
        },
        borderColor: listColor[i],
        borderWidth: 1,
        backgroundColor: listColor[i],
      };
      newList = [...newList, newItem];
    }
    return newList;
  };

  const updateDataset = (listOne) => {
    chartInstance.data.datasets = installDataset(listOne);
    chartInstance.update();
  };

  const data = {
    labels: [],
    datasets: [],
  };

  const chartConfig = {
    data: data,
    options: {
      maintainAspectRatio: false,
      responsive: true,

      plugins: {
        title: {
          display: false,
          text: 'Stacked scales',
        },
        legend: {
          display: true,
        },

        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = 'kWh/kw';
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        y: {
          type: 'linear',
          position: 'left',
          stack: 'demo',
          stackWeight: 2,
          ticks: {
            callback: function (value, index, values) {
              return `${value} kWh/kw`;
            },
          },
        },
      },
    },
  };

  return (
    <>
      <div className={style.chart_detail}>
        <canvas ref={chartRef} />
      </div>
    </>
  );
}

export default AnalysisInfoChart;
